import type { Speed } from "../types";

export const getAnimationDuration = (speed?: Speed): number => {
  const speeds: Record<Speed, number> = {
    slow: 4,
    normal: 3,
    fast: 2,
  }

  const getRandomSpeed = (): Speed => {
    const values: Speed[] = Object.keys(speeds) as Speed[]
    return values[Math.floor(Math.random() * values.length)] ?? 'normal'
  }

  const applicableSpeed: Speed = speed ?? getRandomSpeed()

  return speeds[applicableSpeed]
}
